export function shouldClearStructureHistoryOnUniqueIdChange(
  previousUniqueId: string | null | undefined,
  nextUniqueId: string | null | undefined
): boolean {
  if (previousUniqueId == null || previousUniqueId === '') {
    return false;
  }
  return previousUniqueId !== nextUniqueId;
}
